import { useMemo } from "react";

import { useTireResults } from "../../useTireResults";
import { useTirePLYRating } from "./useTirePLYRating";

export const usePLYOptions = (): Option[] => {
  const { data: info } = useTireResults({
    keepPreviousData: true,
  });
  const [plyRating] = useTirePLYRating();

  const options = useMemo((): Option[] => {
    if (!info) return [];
    const acc = {} as Record<string, null>;
    for (const { partDetails } of info.allParts) {
      const { tirePlyRating } = partDetails.primaryPart;
      acc[tirePlyRating] = null;
    }
    const entries = Object.entries(acc);
    const result = entries
      .map(([tirePlyRating]) => {
        const count = info.allParts.reduce(
          (acc, { partDetails }) =>
            partDetails.primaryPart.tirePlyRating === tirePlyRating
              ? acc + 1
              : acc,
          0
        );
        const checked = plyRating.includes(tirePlyRating);
        return { checked, count, tirePlyRating };
      })
      .sort((a, b) => a.tirePlyRating.localeCompare(b.tirePlyRating));
    return result;
  }, [info?.allParts, plyRating]);

  return options;
};

type Option = {
  checked: boolean;
  count: number;
  tirePlyRating: string;
};
